
import authHeader from "../../../authentication/authservices/auth-header";
import { cssdApiClients } from "../../../http-common";


export const ItemInfoListing = (searchObj) => {
    return cssdApiClients.post(`/item-info/getItemInfoList`, searchObj);
};

export const EmployeeSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/item-allocations/employee-search/${SearchText}`, {
        headers: authHeader(),
    });
};

export const SearchAllocatedata = (id) => {
    return cssdApiClients.get(`/item-allocations/employee/${id}`, {
        headers: authHeader(),
    });
};

export const fetchAllocateSaveData = async (data) => {
    return await cssdApiClients.post('/item-allocations/save', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const FromToSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-allocations/department/${searchText}`, {
        headers: authHeader(),
    });
};

export const fetchSaveTransfertData = async (data) => {
    return await cssdApiClients.post('/item-allocations/asset-transfer/save', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const searchItemNameDropdown = (SearchText) => {
    return cssdApiClients.get(`/item-allocations/item-names/${SearchText}`, {
        headers: authHeader(),
    });
};

export const searchSerialNoDropdown = (SearchText) => {
    return cssdApiClients.get(`/item-allocations/serial-nos/${SearchText}`, {
        headers: authHeader(),
    });
};

export const SearchtransferApprovaldata = async (data) => {
    return await cssdApiClients.post('/item-allocations/approveTransfer/filterList', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const approveTransfer = async (data) => {
    return await cssdApiClients.put('/item-allocations/approve', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const approveTransferList = async (itemInfoId) => {
    return await cssdApiClients.post(`/item-allocations/approveTransfer/filterList/${itemInfoId}`, {
        headers: {
            "Content-Type": "application/json",
        },
    }
    );
};

export const InsuranceListing = (itemInfoId) => {
    return cssdApiClients.get(`/insurance/list/${itemInfoId}`, {
        headers: authHeader(),
    });
};

export const InsuranceTypeSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/insurance/type-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const companySearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/insurance/company-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const agentSearchDropdown = (companyId, SearchText) => {
    return cssdApiClients.get(`/insurance/agent-dropdown/${companyId}/${SearchText}`, {
        headers: authHeader(),
    });
};

export const fetchinsuranceSaveData = async (data) => {
    return await cssdApiClients.post('/insurance/save-or-update', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const AmcListing = (itemInfoId) => {
    return cssdApiClients.get(`/amc/list/${itemInfoId}`, {
        headers: authHeader(),
    });
};

export const AMCAgentSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/amc/serviceAgent-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const MaintenanceTypeSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/amc/maintenanceType-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const AMCTypeSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/amc/amcType-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const fetchAmcSaveData = async (data) => {
    return await cssdApiClients.post('/amc/saveOrUpdate', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const ItemNameSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/itemName-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const BatchNoSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/batch-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const ModelNoSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/model-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const SerialNoSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/serial-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const UplodasExcelSaveData = async (data) => {
    return cssdApiClients.post("/item-info/import-excel", data);

};

export const MaintenanceListing = (itemInfoId) => {
    return cssdApiClients.get(`/maintenance/MaintenanceHistoryList/${itemInfoId}`, {
        headers: authHeader(),
    });
};

export const serviceAgentNameSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/service-agent-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const calibrationMethodSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/calibration-type-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const departmentNameSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/item-allocations/department/${SearchText}`, {
        headers: authHeader(),
    });
};

export const biomedicalSecoundengineerNameSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/biomedical-engineer-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const biomedicalinchargeNameSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/biomedical-incharge-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const SupplierNameSearchDropdown = (SearchText) => {
    return cssdApiClients.get(`/maintenance/supplier-dropdown/${SearchText}`, {
        headers: authHeader(),
    });
};

export const fetchmaintenanceSaveData = async (data) => {
    return await cssdApiClients.post('/maintenance/save-or-update', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const requestCondemnation = (payload) => {
    return cssdApiClients.post(
        "/item-info/condemn/request",
        payload
    );
};

export const approveCondemnation = (payload) => {
    return cssdApiClients.post(
        "/item-info/condemn/approve",
        payload
    );
};

export const getPendingCondemnationList = async (itemInfoId) => {
    return cssdApiClients.get(`/item-info/condemn/pending/${itemInfoId}`);
};

export const ChargesDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/ChargesDropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const CalibrationEquipmentDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/CalibrationEquipmentDropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const MaintenanceDocumentTypeDropdown = (searchText) => {
    return cssdApiClients.get(`/maintenance/MaintenanceDocumentTypeDropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const AssetMakeSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/AssetMake-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const LocationSearchDropdown = (searchText) => {
    return cssdApiClients.get(`/item-info/Location-dropdown/${searchText}`, {
        headers: authHeader(),
    });
};

export const UpdateListing = (id) => {
    return cssdApiClients.get(`/item-info/update-view/${id}`, {
        headers: authHeader(),
    });
};

export const UpdateDataItemInfoList = async (data) => {
    return await cssdApiClients.put('/item-info/update', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};